<script>
export default {
  props: {
    tabs: {
      type: [Object],
      required: true,
    },
    defaultTab: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      activeTab: this.defaultTab,
    };
  },

  created() {
    this.currentTab();
    window.addEventListener('hashchange',() => {
      this.currentTab();
    })
  },

  methods: {
    tabLabel: function(tab) {
      return tab.replace('_', ' ').titleCase();
    },
    toggleTab: function(tab) {
      this.activeTab = tab;
    },
    currentTab() {
      var currentUrl = document.URL;
      var urlParts   = currentUrl.split('#');
      if (urlParts.length > 1) {
        this.activeTab = urlParts[1];
      } else {
        this.activeTab = this.defaultTab;
      }
    },
  },
};
</script>
